import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import ActiveFilterItemLegacy from './_do_not_import_/ActiveFilterItem';
import { ActiveFilterItem as ActiveFilterItemV2, IActiveFilterItemProps } from './_do_not_import_v2_/ActiveFilterItem';

export const ActiveFilterItem = (props: IActiveFilterItemProps) => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <ActiveFilterItemV2 {...props} />;
  }

  return <ActiveFilterItemLegacy {...props} />;
};
